<template>
    <b-modal ref="mdlConfigurazioneParametroVitale" title="Progetto" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Progetto</label>
                <b-form-input v-model="jsonData.nome"> </b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Descrizione</label>
                <b-form-input v-model="jsonData.descrizione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label_data">Data Dal</label>
                <date-picker v-model="jsonData.dataInizio" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label_data">Data Fine</label>
                <date-picker v-model="jsonData.dataFine" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button variant="outline-success" @click="onClickSaveConfigurazioneParametriVitali()">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import ModalError from "../../../template/components/modal/components/ModalError.vue";

export default {
    mixins: [UtilityMixin],
    components: {
        ModalError,
        DatePicker,
    },

    watch: {},
    data() {
        return {
            pathResource: "/pazientiprogetti",
            id: null,
            title: null,
            listKey: 0,
            jsonData: {
                id: null,
                nome: null,
                descrizione: null,
                dataInizio: null,
                dataFine: null,
            },
        };
    },
    mounted() {
        // let me = this;
        // me.loadDizionarioData();
        // me.loadMisurazioni();
    },
    methods: {
        // show(jsonData) {
        //     let me = this;
        //     me.jsonData = jsonData;
        //     me.title = !jsonData.id ? "Nuovo Parametro Vitale" : "Modifica Parametro Vitale";
        //     me.$refs.mdlConfigurazioneParametroVitale.show();
        // },
        setId(id) {
            let me = this;
            me.id = id;
            if (id === null) {
                me.jsonData = { id: null, nome: null, descrizione: null, dataInizio: null, dataFine: null };
            } else {
                me.loadData();
            }

            me.$refs.mdlConfigurazioneParametroVitale.show();
        },
        loadData() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            // console.log(me.jsonData);
        },
        loadDataError(error) {
            console.log("Errore nel caricamento", error);
        },
        onCloseModal() {
            let me = this;
            me.jsonData = { id: null, nome: null, descrizione: null, dataInizio: null, dataFine: null };
            me.$refs.mdlConfigurazioneParametroVitale.hide();
            me.$emit("onCloseModal");
        },
        onClickSaveConfigurazioneParametriVitali() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.saveConfigurazioneParametriVitaliSuccess, me.saveConfigurazioneParametriVitaliError);
        },
        saveConfigurazioneParametriVitaliSuccess(response) {
            let me = this;
            me.$emit("onSaveParametroVitale", response);
            me.$refs.mdlConfigurazioneParametroVitale.hide();
            me.$bvToast.toast("Salvataggio avvvenuto con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });
        },
        saveConfigurazioneParametriVitaliError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
    },
};
</script>
